import StockControlList from "@/views/stockControl/StockControlList";

export default StockControlList;
